export default "__VITE_ASSET__BxX2WMll__"